import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faEye } from '@fortawesome/free-solid-svg-icons';
import '../../styles/AdminDataTable.css';
import UserDetailsModal from './UserDetailsModal';

const UsersTable = ({ users, onEdit, onDelete, onUserSelect, selectAll, onSelectAll }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const sortedUsers = [...users].sort((a, b) => {
    if (a.is_superuser && !b.is_superuser) {
      return -1;
    }
    if (!a.is_superuser && b.is_superuser) {
      return 1;
    }
    return 0;
  });

  const handleViewClick = (user) => {
    setSelectedUser(user);
    setModalOpen(true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    setSelectedUser(null);
  };

  return (
    <div className="admin-data-table__container">
      <table className="admin-data-table">
        <thead>
          <tr>
            <th>
              <input
                type="checkbox"
                checked={selectAll}
                onChange={(e) => onSelectAll(e.target.checked)}
              />
            </th>
            <th>ID</th>
            <th>Name</th>
            <th>Verified</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Date Joined</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {sortedUsers.map((user) => (
            <tr key={user.id} >
              <td>
                <input
                  type="checkbox"
                  checked={user.isSelected || false}
                  onChange={(e) => onUserSelect(user.id, e.target.checked)}
                />
              </td>
              <td>#{user.id}</td>
              <td>
                {user.full_name}
              </td>
              <td>{user.is_active ? 'Yes' : 'No'}</td>
              <td>{user.email}</td>
              <td>{user.phone}</td>
              <td>{user.formatted_date_joined}</td>
              <td>
                <div className="action-buttons">
                  <button className="button secondary" onClick={() => onDelete(user)}>
                    <FontAwesomeIcon icon={faTrashAlt} />
                  </button>

                  {user.is_superuser ? (
                    <button className="button secondary" onClick={() => onEdit(user)}>
                      <FontAwesomeIcon icon={faEdit} />
                    </button>
                  ) : (
                    <button className="button secondary" onClick={() => handleViewClick(user)}>
                      <FontAwesomeIcon icon={faEye} />
                    </button>
                  )}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <UserDetailsModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        user={selectedUser}
      />
    </div>
  );
};

export default UsersTable;